import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var ButtonGroup = React.forwardRef(function ButtonGroup(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "outlined" : _b, theme = _a.theme, size = _a.size, shape = _a.shape, disabled = _a.disabled, children = _a.children, className = _a.className, style = _a.style, props = __rest(_a, ["variant", "theme", "size", "shape", "disabled", "children", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    var ButtonGroupClassName = classNames(classPrefix + "-btn-group", classPrefix + "-btn-group--" + variant, className, {
        "is-disabled": disabled,
    });
    var renderButtons = function () {
        return React.Children.map(children, function (child) {
            if (!React.isValidElement(child))
                return null;
            var childVariant = variant || child.props.variant || "outlined";
            if (typeof child.props.variant !== "undefined" &&
                (child.props.variant !== "solid" || child.props.variant !== "outlined")) {
                console.warn("Button group only allows solid or outlined types");
            }
            if (disabled && typeof child.props.disabled === "undefined") {
                child.props.disabled = true;
            }
            var copyChild = React.cloneElement(child, {
                variant: childVariant,
                theme: typeof theme !== "undefined" ? theme : child.props.theme,
                size: typeof size !== "undefined" ? size : child.props.size,
                shape: typeof shape !== "undefined" ? shape : child.props.shape,
                disabled: disabled || child.props.disabled,
            });
            return copyChild;
        });
    };
    var content = (React.createElement("div", __assign({ className: ButtonGroupClassName, ref: ref, style: style }, props), renderButtons()));
    return content;
});
ButtonGroup.displayName = "ButtonGroup";
//# sourceMappingURL=ButtonGroup.js.map